import { Link } from "react-router-dom";
import { Phone, ShieldCheck, Clock, Star } from "lucide-react";
import LeadForm from "../forms/LeadForm";
import config from "../../config/stateConfig";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/58623b2a-7faf-45b8-a4fb-9395fbe995ba/images/b7a3be993cf7c9c34ad344c1760ab79eb971e9a42c683cca3c21e55978f82bd7.png";

export default function Hero() {
  return (
    <section
      className="relative overflow-hidden bg-bone pt-12 md:pt-20 pb-16 md:pb-28 px-6 grain"
      data-testid="hero-section"
    >
      <div
        className="absolute inset-0 -z-10 opacity-30 lg:opacity-50"
        style={{
          backgroundImage: `linear-gradient(to right, rgba(249,248,246,1) 0%, rgba(249,248,246,0.92) 35%, rgba(249,248,246,0.4) 70%, rgba(249,248,246,0) 100%), url(${HERO_IMG})`,
          backgroundSize: "cover",
          backgroundPosition: "center right",
        }}
      />

      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 bg-forest/5 text-forest text-xs font-bold px-3 py-1.5 rounded-full mb-6">
            <span className="w-1.5 h-1.5 rounded-full bg-terracotta animate-pulse"></span>
            AVAILABLE 24/7 · {config.serviceTagline}
          </div>
          <h1
            className="text-4xl sm:text-5xl lg:text-7xl font-display font-black text-forest tracking-tightest leading-[0.98] text-balance mb-6"
            data-testid="hero-headline"
          >
            Hurt in a {config.stateName} accident?
            <br />
            <span className="text-terracotta">We're here.</span>
          </h1>
          <p className="text-lg md:text-xl text-charcoal-soft max-w-2xl leading-relaxed mb-8">
            Free, confidential help for accident victims across {config.stateName}. We connect you with
            experienced local attorneys who fight for what you deserve. No fees unless you win.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 mb-10">
            <a href={`tel:${config.phoneTel}`} className="btn-primary text-lg py-4 px-8" data-testid="hero-call-button">
              <Phone className="w-5 h-5" />
              Call {config.phone}
            </a>
            <Link
              to="/contact"
              className="btn-ghost text-lg py-4 px-8"
              data-testid="hero-form-button"
              data-attorney-contact="true"
              data-source="hero_cta"
            >
              Free Case Review
            </Link>
          </div>

          {/* Trust strip */}
          <div className="grid grid-cols-3 gap-4 max-w-xl">
            <Trust icon={<Clock className="w-5 h-5" />} title="24/7" sub="Always available" />
            <Trust icon={<ShieldCheck className="w-5 h-5" />} title="100% Free" sub="No-obligation review" />
            <Trust icon={<Star className="w-5 h-5" />} title="No Win, No Fee" sub="Contingency-based" />
          </div>
        </div>

        {/* Form column */}
        <div className="lg:col-span-5 animate-fade-up">
          <LeadForm compact />
        </div>
      </div>
    </section>
  );
}

function Trust({ icon, title, sub }) {
  return (
    <div className="flex items-start gap-3">
      <div className="w-9 h-9 rounded-full bg-forest text-bone grid place-items-center shrink-0">
        {icon}
      </div>
      <div className="leading-tight">
        <div className="font-display font-bold text-forest text-lg">{title}</div>
        <div className="text-xs text-charcoal-soft">{sub}</div>
      </div>
    </div>
  );
}
